// extracted by mini-css-extract-plugin
export default {"chart":"Chart_chart__fr5ME","chart-word-cloud":"Chart_chart-word-cloud__IVv3a","chart-loader":"Chart_chart-loader__ofC+u"};